const styles = (theme) => ({
  highlighted: {
    color: theme.palette.primary.white,
    background: theme.palette.primary.green,
  },
});

export default styles;
